import { Localisation } from 'assets/icons';
import {
  formatTemplateCity,
  formatTemplateRate,
  getTemplateTitle,
} from './missionTemplateFormat';

/** A job description as the grid shows it: what it is, where, and for how much. */
const TemplateCard = ({ template, onOpen }) => {
  const city = formatTemplateCity(template?.location);
  const rate = formatTemplateRate(template);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onOpen(template)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onOpen(template);
        }
      }}
      className={`flex flex-col gap-4 p-4 bg-white border rounded-lg cursor-pointer text-left hover:border-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500 ${
        template?.isBelowMinimumWage
          ? 'border-red-200 bg-red-50'
          : 'border-gray-100'
      }`}
    >
      <div className="flex flex-col">
        <span className="ft-sm font-medium text-gray-900 break-words">
          {getTemplateTitle(template)}
        </span>
        <span className="ft-sm text-gray-500 break-words">
          {template?.activity || '-'}
        </span>
      </div>
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1 ft-sm text-gray-500 min-w-0">
          <span aria-hidden="true" className="shrink-0">
            <Localisation wh={16} color="#6B7280" />
          </span>
          <span className="truncate">{city || '-'}</span>
        </span>
        {rate ? (
          <span className="ft-sm text-gray-900 shrink-0">
            <span className="font-medium">{rate}</span>
            <span className="text-gray-500"> /h</span>
          </span>
        ) : null}
      </div>
      {template?.isBelowMinimumWage ? (
        <span className="ft-xs text-red-500">
          Sous le SMIC : cette fiche ne peut pas démarrer une mission.
        </span>
      ) : null}
    </div>
  );
};

export default TemplateCard;
